// 机器指纹
import Fingerprintjs2 from 'fingerprintjs2'
// 先获取指纹
let fingerprintId = localStorage.getItem('deviceId')
// 如果没有的话
if (!fingerprintId) {
    // 生成指纹
    Fingerprintjs2.get(function (result) {
        fingerprintId = Fingerprintjs2.x64hash128(result.join(''), 31)
        localStorage.setItem('deviceId', fingerprintId)
    })
}
const navigator = window.navigator
function getOs () {
    const u = navigator.userAgent.toLowerCase()
    let osName = ''
    if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        osName = 'ios'
    } else if (u.indexOf('android') > -1 || u.indexOf('adr') > -1) {
        osName = 'Android'
    } else if (u.indexOf('windows') > -1) {
        osName = 'windows'
    }
    return osName
}
function getDeviceType(s) {
    var _flag = false;

    if (window.navigator.userAgent) {
        var ua = window.navigator.userAgent.toLowerCase();
        var type = s.toLowerCase();

        if (type && ua.indexOf(type, 0) != -1) {
            _flag = true;
        }
    }

    return _flag;
}
function isInApp() {
    return getDeviceType('atourbrowser');
}
function isIos() {
    return getDeviceType('ios');
}
function getPlatTypePromise() {
    return new Promise(function (resolve) {
        let platType = window.localStorage.getItem('platType')
        if (platType) {
            resolve(platType);
        } else {
            var resolveP = function resolveP(type) {
                platType = type;
                window.localStorage.setItem('platType', platType)
                resolve(type);
            };

            var ua = navigator.userAgent.toLowerCase();

            if (ua.indexOf('micromessenger') > -1) {
                if (wx) {
                    wx.miniProgram.getEnv(function (res) {
                        if (res.miniprogram) {
                            console.log('微信小程序');
                            resolveP(6);
                        } else {
                            console.log('不在微信小程序');
                            resolveP(3);
                        }
                    });
                } else {
                    resolveP(3);
                }
            } else if (ua.indexOf('alipayclient') > -1) {
                if (my) {
                    my.getEnv(function (res) {
                        if (res.miniprogram) {
                            console.log('支付宝小程序');
                            resolveP(13);
                        } else {
                            console.log('不在支付宝小程序');
                            resolveP(3);
                        }
                    });
                } else {
                    resolveP(3);
                }
            } else {
                console.log('其他环境');

                if (isInApp()) {
                    if (isIos()) {
                        resolveP(2);
                    } else {
                        resolveP(1);
                    }
                } else {
                    resolveP(5);
                }
            }
        }
    });
}
function getQuery(name) {
    const queryString = window.location.href.split('?')[1] || ''
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = queryString.match(reg);
    let rel = ''
    if (r != null) {
        rel = r[2] || ''
    }
    return rel
}

function sendRport ({ actionType = 'PV_UV', elementId, pageId = 0}) {
    let url = ''
    getPlatTypePromise().then(platType => {
        const data = {
            traceId: sessionStorage.getItem('traceId') || 0,
            elementId,
            pageId,
            version: sessionStorage.getItem('version') || localStorage.getItem('version') || '2.6.0',
            appVer: sessionStorage.getItem('version') || localStorage.getItem('version') || '2.6.0',
            clientId: platType,
            platType: platType,
            channelId: 300001,
            activitySource: getQuery('activitySource'),
            activityId: getQuery('activityId'),
            activeId: getQuery('activeId'),
            token: sessionStorage.getItem('token') || localStorage.getItem('token') || '',
            deviceId: fingerprintId,
            actionType
        }
        if (process.env.NODE_ENV === 'gqc') {
            url = window.location.protocol + '//miniapp.yaduo.com/atourlife/track/report'
        } else {
            url = window.location.protocol + "//betab-api.at-our.com/atourlife/track/report"
        }
        site._get(url, data)
    })
}
export const reportNew = {
    pv (option) {
        sendRport(option)
    },
    click (option) {
        const clickOption = JSON.parse(JSON.stringify(option))
        clickOption.actionType = 'CLICK_EVENT'
        sendRport(clickOption)
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/reportNew.js